export default [
  { to: 'a_omhandertagande', title: 'Akut omhändertagande' },
  { to: 'specifika_tillstand', title: 'Trafikolycka' },
];
